import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

// Styled container for the <Select>
const SelectContainer = styled.div`
  position: relative;
`;

const StyledSelect = styled.select`
  color: ${({ selected }) => selected ? 'inherit' : '#75828a'};
  width: 100%;
  height: 4rem;
  padding: 8px 12px;
  font-size: 1.4rem;
  border: 1px solid #ccc;
  appearance: none;
  background: #fff;
  cursor: pointer;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    outline: none;
  }
`;

const DropdownArrow = styled.div`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  pointer-events: none;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #000;
`;

const Select = ({ options, placeholder, id, name, onChange }) => {
  const [selected, setSelected] = useState(false);
  const handleOnChange = useCallback((event) => {
    const { value } = event.target;
    setSelected(value !== "")
    onChange(event, { name, value })
  }, [onChange, name])

  return (
    <SelectContainer>
      <StyledSelect id={id} name={name} onChange={handleOnChange} defaultValue="" selected={selected}>
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
      <DropdownArrow />
    </SelectContainer>
  );
};

export default Select;
